<template>
  <div>
    <!-- Header -->
    <header-view />

    <!-- Content -->
    <section class="content">
      <router-view :key="$route.fullPath" />
    </section>

    <!-- Footer -->
    <footer-view />
  </div>
</template>

<script>
export default {
  components: {
    HeaderView: () => import('@/components/header/header-view'),
    FooterView: () => import('@/components/footer/footer-view')
  }
};
</script>



// WEBPACK FOOTER //
// primary.vue